var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ht-100p"},[_c('div',{staticClass:"nav nav-sidebar text-center ht-100p",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('on-show-point')}}},[_c('main',{staticClass:"ht-100p",staticStyle:{"display":"grid","grid-template-columns":"repeat(1, 1fr)","max-width":"100","width":"100%"}},[_c('div',{staticClass:"nav-point tx-bold ht-100p-f",class:{
          'point-success-main': _vm.sumPoint >= _vm.tmzPointSuccess,
          'point-warning-main':
            _vm.sumPoint > _vm.tmzPointWarning && _vm.sumPoint < _vm.tmzPointSuccess,
          'point-danger-main': _vm.sumPoint <= _vm.tmzPointWarning && _vm.sumPoint > 0
        }},[_vm._v(" "+_vm._s(_vm.sumPoint)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }